import script from "./CollectionProductList.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionProductList.vue?vue&type=script&setup=true&lang=js"

import "./CollectionProductList.vue?vue&type=style&index=0&id=c0c7695c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0c7695c"]])

export default __exports__